import { useInfiniteQuery } from '@tanstack/react-query';

import { getNextPageParam } from '@pkg/hooks/deprecated';

import { type ResourceId } from '@app/client';
import { callGetYatPageLinks } from '@app/client/resources/yat-pages/page-items';

export const USER_YAT_PAGE_LINKS = 'USER_YAT_PAGE_LINKS';

export interface GetYatPageLinksHookOptions {
    eid?: ResourceId;
}

export function useGetYatPageLinks({ eid }: GetYatPageLinksHookOptions) {
    return useInfiniteQuery({
        queryKey: [USER_YAT_PAGE_LINKS, eid],
        queryFn: ({ pageParam }) =>
            callGetYatPageLinks({
                eid: eid || '',
                page: pageParam,
                limit: 30,
            }),
        enabled: !!eid,
        retry: false,
        initialPageParam: 0,
        getNextPageParam,
    });
}
